document.onload = () => {
  // comment
  console.log('ok');
};
